module.exports = __webpack_public_path__ + "img/dyyyicon.d2784caf.svg";